<template>
  <el-card class="box-card client-card" :body-style="{ padding: '20px 20px 2px 20px' }">
    <div slot="header" class="clearfix">
      <el-row :gutter="0">
        <el-col class="icon">
          <i class="far fa-user-circle" /><br>
        </el-col>
        <el-col class="title">
          <h2>{{ name }} <span>{{ title }}</span></h2>
          <i class="fa fa-university pl-0" v-if="ssn"></i>&nbsp;{{ ssn }}
          <i class="fa fa-id-card" v-if="stateId"></i>&nbsp;{{ stateId }}
        </el-col>
        <el-col class="action-buttons">
          <slot name="actions"></slot>
        </el-col>
      </el-row>
    </div>
    <slot></slot>
  </el-card>
</template>

<script>

export default {
  props: {
    name: String,
    title: String,
    ssn: String,
    stateId: String,
  },
};

</script>

<style lang="scss">

.client-card {
  .icon {
    float: left;
    text-align: center;
    width: 70px;
    line-height: 1;
    font-size: 50px;

    span {
      font-size: 14px;
      color: #999;
    }
  }

  .title {
    width: max-content;
    h2 {
    margin: 0;
    padding: 0 5px;

      span {
        font-weight: normal;
        font-size: 0.6em;
      }
    }

    span {
      color: #999;
      font-size: 0.85em;
      text-transform: uppercase;
    }
  }

  .action-buttons {
    float: right;
    text-align: right;
    font-size: 14px;
    width: max-content;

    button {
      padding: 5px;
      margin-left: 5px;
    }
  }
}
</style>
